var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-listing" },
    [
      _c(
        "div",
        { staticClass: "email-listing__heading" },
        [
          _c("h1", [_vm._v(_vm._s(_vm.$t.__("email.EmailListing.title")))]),
          _vm._v(" "),
          _vm.onOutboxPage && _vm.emailsNotEmpty
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("email.EmailListing.resend_failed_emails"),
                  leftIcon: "reload"
                },
                on: { click: _vm.handleResendFailedEmails }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isProvidersErrorPage
        ? _c("router-view", { key: _vm.$route.path })
        : _c(
            "LayoutWithNavigation",
            [
              _c(
                "template",
                { slot: "navigation" },
                [
                  _c("CompassSideNav", {
                    attrs: { menuItems: _vm.formattedNavItems }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "default" },
                [
                  _c("router-view", {
                    key: _vm.$route.path,
                    on: { "emails-status": _vm.updateEmailsStatus }
                  })
                ],
                1
              )
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }